// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sortable Ledger column header — a button that inherits the <th> mono head
   type, with a quiet idle glyph and a blue arrow on the active sort key. */
.ledger-sort-head {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  color: inherit;
  transition: color 100ms ease;
}

.ledger-sort-head:hover,
.ledger-sort-head.is-active {
  color: var(--text);
}

.ledger-sort-head:focus-visible {
  outline: none;
  color: var(--text);
}

.ledger-sort-arrow {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.ledger-sort-head.is-active .ledger-sort-arrow {
  color: var(--signal);
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ledger/SortHead.css"],"names":[],"mappings":"AAAA;2EAC2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* Sortable Ledger column header — a button that inherits the <th> mono head\n   type, with a quiet idle glyph and a blue arrow on the active sort key. */\n.ledger-sort-head {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  color: inherit;\n  transition: color 100ms ease;\n}\n\n.ledger-sort-head:hover,\n.ledger-sort-head.is-active {\n  color: var(--text);\n}\n\n.ledger-sort-head:focus-visible {\n  outline: none;\n  color: var(--text);\n}\n\n.ledger-sort-arrow {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}\n\n.ledger-sort-head.is-active .ledger-sort-arrow {\n  color: var(--signal);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
